const projects = [
    {
        "id": 1,
        "logo": require("./images/inspect-logo.png"),
        "img": require("./images/inspect-branding.png"),
        "alt": "inspect",
        "feature1": "",
        "imgFeature1":require("./images/inspect-branding.png"),
        "feature2": "Search term limits marker visibility",
        "imgFeature2":require("./images/inspect-branding.png"),
        "alt3": "restaurant locator app",
        "imgFeature3":require("./images/inspect-branding.png"),
        "featured": false,
        "title": "Inspect Building",
        "subtitle": "What is the energy code of this building?!",
        "desc": "A visual inspection tool for city officials to more efficiently inspect buildings to meet California’s Title 24, Building Energy Efficiency Standards",
        "features": "Gets the building floor plan, and the most important questions.",
        "skills": "Node, JavaScript, EJS, HTML, CSS",
        "code": "https://github.com/juancarlucci/build",
        "site": "https://inspect-building.herokuapp.com/"
    },
    {
        "id": 2,
        "logo": require("./images/butter-logo.png"),
        "img":require("./images/butter-map-branding.png"),
        "alt": "restaurant locator app",
        "feature1": "Search term limits marker visibility",
        "imgFeature1":require("./images/search-map.png"),
        "feature2": "Custom styles",
        "imgFeature2":require("./images/custom.png"),
        "alt3": "restaurant locator app",
        "imgFeature3":require("./images/butter-map-branding.png"),
        "featured": false,
        "title": "Artisanal Butter Finder",
        "subtitle": "Interactive map",
        "desc": "Locate Bay Area restaurants that use real butter.",
        "features": "Includes a search function and nearby attractions via Wikimedia API.",
        "skills": "AJAX, JavaScript Design Patterns, Google API, Wikimedia API",
        "code": "https://github.com/juancarlucci/map",
        "site": "https://juancarlucci.github.io/map/"
    },
    // {
    //     "id": 3,
    //     "logo": require("./images/3d-logo.svg"),
    //     "img":require("./images/3d-branding.png"),
    //     "alt": "codeInsight app photo",
    //     "feature1": "",
    //     "imgFeature1":require("./images/butter-map-branding.png"),
    //     "feature2": "Search term limits marker visibility",
    //     "imgFeature2":require("./images/butter-map-branding.png"),
    //     "alt3": "restaurant locator app",
    //     "imgFeature3":require("./images/butter-map-branding.png"),
    //     "featured": false,
    //     "title": "3D",
    //     "subtitle": "From data to building",
    //     "desc": "Three-d rendering engine",
    //     "features": "Using canvas and data we get three dimensional spaces. The walls are layered.",
    //     "skills": "HTML5|CSS3|JavaScrip|Canvas",
    //     "code": "https://github.com/juancarlucci/",
    //     "site": ""
    // },
    // {
    //     "id": 4,
    //     "logo": require("./images/codeinsight-logo.png"),
    //     "img":require("./images/codeinsight-branding.png"),
    //     "alt": "codeInsight app photo",
    //     "feature1": "",
    //     "imgFeature1":require("./images/butter-map-branding.png"),
    //     "feature2": "Search term limits marker visibility",
    //     "imgFeature2":require("./images/butter-map-branding.png"),
    //     "alt3": "restaurant locator app",
    //     "imgFeature3":require("./images/butter-map-branding.png"),
    //     "featured": false,
    //     "title": "codeInsight",
    //     "subtitle": "OAuth, RESTful",
    //     "desc": "Full-stack app to display Github user statistics.",
    //     "features": "The main page is an insights dashboard displaying publicly available information via Github’s API. Information is displayed as graphs/charts representing major trends in the users own repo history. User can navigate to What’s Hot page for statistics for all Github repos.",
    //     "skills": "Backend-Node.js|MongoDb|Express. Frontend- HTML5|CSS3|JavaScrip|D3.js",
    //     "code": "https://github.com/juancarlucci/codeinsight",
    //     "site": "https://codeinsight.herokuapp.com/"
    // },
    // {
    //     "id": 5,
    //     "logo": require("./images/pre-check-logo.png"),
    //     "img":require("./images/pre-check-branding.png"),
    //     "alt": "pre-check app photo",
    //     "feature1": "",
    //     "imgFeature1":require("./images/butter-map-branding.png"),
    //     "feature2": "Search term limits marker visibility",
    //     "imgFeature2":require("./images/butter-map-branding.png"),
    //     "alt3": "restaurant locator app",
    //     "imgFeature3":require("./images/butter-map-branding.png"),
    //     "featured": false,
    //     "title": "Compliance Assistance Tool",
    //     "subtitle": "Even prints a PDF report",
    //     "desc": "Making compliance automated",
    //     "features": "Designers and architects can more easily comply with California Title 24 using this tool.",
    //     "skills": "Backend-Node.js|Express. Frontend- HTML5|CSS3|JavaScrip|Canvas",
    //     "code": "",
    //     "site": ""
    // },
    {
        "id": 6,
        "logo": require("./images/monument-logo.png"),
        "img": require("./images/monument-branding.png"),
        "alt": "monument",
        "feature1": "Semantic HTML5",
        "imgFeature1":require("./images/butter-map-branding.png"),
        "feature2": "Use of Sass",
        "imgFeature2":require("./images/butter-map-branding.png"),
        "alt3": "Translating comps and wireframes into flexible and reusable code",
        "imgFeature3":require("./images/butter-map-branding.png"),
        "featured": false,
        "title": "Monument: comps and wireframes",
        "subtitle": "Flexible and reusable code!",
        "desc": "Monument is a responsive style magazine mockup.",
        "features": "Semantic HTML5. Sass for CSS. Front end validation for user forms. Smooth scrolling across pages.",
        "skills": "HTML5, CSS3, Sass, jQuery, JavaScript",
        "code": "https://github.com/juancarlucci/monument",
        "site": "https://juancarlucci.github.io/monument/"
    },
    // {
    //     "id": 3.2,
    //     "logo": require("./images/mytasks-logo.png"),
    //     "img": require("./images/react-app-branding.png"),
    //     "alt": "react app image",
    //     "feature1": "",
    //     "imgFeature1":require("./images/butter-map-branding.png"),
    //     "feature2": "Search term limits marker visibility",
    //     "imgFeature2":require("./images/butter-map-branding.png"),
    //     "alt3": "restaurant locator app",
    //     "imgFeature3":require("./images/butter-map-branding.png"),
    //     "featured": false,
    //     "title": "My Tasks Today",
    //     "subtitle": "React.js",
    //     "desc": "React.js app that allows the user to create a list of tasks. The list is editable. The app makes API calls to create, edit, delete and store tasks.",
    //     "features": "Data stored in API. CRUD capabilities.",
    //     "skills": "React.js, Axios, JavaScript, HTML5, CSS3, Semantic-UI-React",
    //     "code": "https://github.com/juancarlucci/react-mytasks",
    //     "site": "https://juancarlucci.github.io/react-mytasks/"
    // },
    // {
    //     "id": 7,
    //     "logo": require("./images/community-logo.png"),
    //     "img": require("./images/community-branding.png"),
    //     "alt": "Community Projects Map image",
    //     "feature1": "",
    //     "imgFeature1":require("./images/butter-map-branding.png"),
    //     "feature2": "Search term limits marker visibility",
    //     "imgFeature2":require("./images/butter-map-branding.png"),
    //     "alt3": "restaurant locator app",
    //     "imgFeature3":require("./images/butter-map-branding.png"),
    //     "featured": false,
    //     "title": "Community Projects Map",
    //     "subtitle": "Update via Google Sheets",
    //     "desc": "This project was done on a pro-bono basis for a non-profit looking to explore possibilities for mapping their community projects. The organization was looking for a colorful, easy to maintain map.",
    //     "features": "All marker data is stored in an easily accessible Google spreadsheet. This gave the organization direct access to updating the data without having to update the app's javascript files. We used Tabeltop.js to achieve this. Created wireframe using InVision and got client input. Created assets using Adobe Illustrator (markers, logo).",
    //     "skills": "JavaScript, HTML5, CSS3, Leaflet.js, Mapbox, Tabletop.js, Adobe Illustrator",
    //     "code": "https://github.com/juancarlucci/community-projects",
    //     "site": "https://juancarlucci.github.io/community-projects/"
    // },
    {
        "id": 8,
        "logo": require("./images/copa-logo.png"),
        "img": require("./images/world-cup-branding.png"),
        "alt": "Sample photo",
        "feature1": "",
        "imgFeature1":require("./images/butter-map-branding.png"),
        "feature2": "Search term limits marker visibility",
        "imgFeature2":require("./images/butter-map-branding.png"),
        "alt3": "restaurant locator app",
        "imgFeature3":require("./images/butter-map-branding.png"),
        "featured": true,
        "title": "World Cup 1930-2014",
        "subtitle": "D3.js Animated SVG map",
        "desc": "Watch a D3 animation of where each world cup was held.",
        "features": "SVG map displays data by year, winning country and number of participating countries. Hover states on graph reveal data for match, score and year.",
        "skills": "D3.js, responsive svg, nest, rollup, leaves, transitions, and scales",
        "code": "https://github.com/juancarlucci/worldcup",
        "site": "https://juancarlucci.github.io/worldcup/"
    },
    //  {
    //     "id": 7,
    //     "logo": require("./images/energy-logo.png"),
    //     "img": require("./images/energy-savings-branding.png"),
    //     "alt": "energy savings map",
    //     "feature1": "",
    //     "imgFeature1":require("./images/energy-map-branding.png"),
    //     "feature2": "Search term limits marker visibility",
    //     "imgFeature2":require("./images/energy-map-branding.png"),
    //     "alt3": "restaurant locator app",
    //     "imgFeature3":require("./images/energy-map-branding.png"),
    //     "featured": false,
    //     "title": "Energy Savings Map",
    //     "subtitle": "D3 + Mapbox",
    //     "desc": "A map depicting the energy saved by incorporating automated inspection tools for inspectors.",
    //     "features": "D3-based interactive charts.",
    //     "skills": "JavaScript, Mapbox, D3.js",
    //     "code": "https://github.com/juancarlucci/react-mytasks",
    //     "site": "https://juancarlucci.github.io/react-mytasks/"
    // },
    // {
    //     "id": 8,
    //     "logo": require("./images/eventures-logo.png"),
    //     "img": require("./images/eventure-branding.png"),
    //     "alt": "eventures",
    //     "feature1": "",
    //     "imgFeature1":require("./images/butter-map-branding.png"),
    //     "feature2": "Search term limits marker visibility",
    //     "imgFeature2":require("./images/butter-map-branding.png"),
    //     "alt3": "restaurant locator app",
    //     "imgFeature3":require("./images/butter-map-branding.png"),
    //     "featured": false,
    //     "title": "Eventures",
    //     "subtitle": "See what's happening in the city!",
    //     "desc": "Eventures is a site where users can see events happening in San Francisco.",
    //     "features": "User creation with password using bcrypt. API calls to Evenbrite.",
    //     "skills": "Ruby on Rails, API integration, bcrypt, JavaScript",
    //     "code": "https://github.com/juancarlucci/Eventures",
    //     "site": ""
    // }
]

export default projects;



// WEBPACK FOOTER //
// ./src/projects2.js